export default "__VITE_ASSET__BFbjRuc2__"